import React from "react";
import styled from "styled-components";
import Globais from "../../css/Globais";

const secoes = [
  {
    titulo: "1.	IDENTIFICAÇÃO E ESCOPO",
    conteudo: `
1.1.	A presente Política de Privacidade descreve como a Multicotas coleta, utiliza, compartilha, armazena e protege os dados pessoais de usuários, proprietários, compradores, vendedores, hóspedes, interessados, representantes, procuradores e demais pessoas que utilizem os serviços, site, aplicativos, canais de atendimento, formulários, anúncios e plataformas da empresa.

1.2.	Esta Política aplica-se a todos os serviços prestados pela Multicotas, incluindo, mas sem limitação:
•	cadastro e uso da plataforma;
•	anúncios de venda de cotas;
•	anúncios e intermediação de locação;
•	intermediação de trocas de períodos;
•	solicitações de reserva e hospedagem;
•	análise e intermediação de financiamento;
•	envio de documentos e comprovação de titularidade;
•	atendimento por WhatsApp, telefone, e-mail e redes sociais;
•	pagamentos, cobranças e repasses;
•	participação em campanhas, promoções e ações de marketing.

1.3.	A Multicotas atua como controladora dos dados pessoais tratados no contexto de seus serviços.
Dados para contato:
•	Razão social: TELLES SOLUÇÕES EM TECNOLOGIA LTDA
•	Nome fantasia: MULTICOTAS
•	CNPJ: 33.600.316/0001-73
•	Endereço: na Avenida Geremário Dantas, nº 968, 203 Bloco 4, Jacarepaguá, Rio de Janeiro – RJ, CEP: 22743-010
•	E-mail geral: contato@multicotas.com.br
•	E-mail do encarregado de dados (DPO): privacidade@multicotas.com.br
    `,
  },
  {
    titulo: "2. DEFINIÇÕES",
    conteudo: `
Para fins desta Política:

2.1.	Dados Pessoais
Informações relacionadas a pessoa natural identificada ou identificável, como nome, CPF, telefone, e-mail ou endereço.

2.2.	Dados Sensíveis
Dados sobre origem racial ou étnica, convicção religiosa, opinião política, filiação sindical, dados referentes à saúde, biometria ou vida sexual.

2.3.	Titular
Pessoa a quem os dados pessoais se referem.

2.4.	Tratamento
Toda operação realizada com dados pessoais, incluindo coleta, armazenamento, uso, compartilhamento, eliminação e demais atividades.

2.5.	Controlador
Pessoa ou empresa responsável pelas decisões referentes ao tratamento dos dados pessoais.

2.6.	Operador
Pessoa ou empresa que realiza o tratamento de dados em nome da Multicotas.

2.7.	Proprietário
Pessoa que anuncia, vende, loca, troca ou disponibiliza cotas, semanas, períodos ou frações por meio da Multicotas.

2.8.	Hóspede
Pessoa que utilizará a hospedagem ou reserva intermediada pela Multicotas.

2.9.	Parceiros
Empresas, resorts, hotéis, administradoras, processadores de pagamento, financeiras, plataformas e demais terceiros que participem da prestação dos serviços.

2.10.	Cookies
Arquivos ou identificadores armazenados no dispositivo do usuário para possibilitar o funcionamento do site, personalização, estatísticas e marketing.
    `,
  },
  {
    titulo: "3.	QUAIS DADOS COLETAMOS",
    conteudo: `
A Multicotas poderá coletar os seguintes dados, conforme o serviço utilizado.

3.1.	Dados Cadastrais

•	nome completo;
•	CPF;
•	RG, CNH, passaporte ou outro documento;
•	data de nascimento;
•	telefone e WhatsApp;
•	e-mail;
•	endereço completo;
•	cidade, estado e CEP;
•	foto de perfil ou imagem enviada;
•	profissão e estado civil, quando necessário.

3.2.	Dados de Titularidade e Multipropriedade

•	empreendimento, resort ou hotel;
•	unidade, apartamento, fração ou cota;
•	semana ou período;
•	contrato da cota;
•	saldo devedor e situação financeira da cota;
•	histórico de uso, locação, venda ou troca;
•	documentos comprobatórios de titularidade;
•	escritura, cessão, contrato ou instrumento equivalente;
•	procurações;
•	documentos do representante legal ou procurador.

3.3.	Dados de Reserva e Hospedagem

•	datas desejadas de hospedagem;
•	destino, empreendimento e período;
•	quantidade de hóspedes;
•	nomes dos hóspedes;
•	CPF, RG, passaporte ou data de nascimento dos hóspedes;
•	informações necessárias ao check-in;
•	preferências de hospedagem, quando informadas;
•	dados exigidos por hotéis, resorts, companhias aéreas ou parceiros.

3.4.	Dados Financeiros e de Pagamento

•	dados bancários;
•	conta, agência e chave Pix;
•	comprovantes de pagamento;
•	histórico de pagamentos e recebimentos;
•	dados de cobrança;
•	parcelamentos;
•	saldo devedor;
•	valores pagos ou a receber;
•	notas fiscais e informações tributárias.

3.4.1.	A Multicotas não armazena integralmente os dados de cartão de crédito, que são processados por intermediadores de pagamento e instituições financeiras parceiras.

3.5.	Dados para Financiamento

Quando o usuário solicitar ou autorizar análise de financiamento, poderão ser coletados:
•	renda;
•	profissão;
•	comprovantes de renda;
•	extratos;
•	histórico de pagamento;
•	saldo devedor;
•	documentos pessoais;
•	informações adicionais exigidas pela instituição financeira.

3.6.	Dados de Comunicação

•	mensagens enviadas via WhatsApp, chat, e-mail ou formulário;
•	gravações de ligações, quando aplicável;
•	histórico de atendimento;
•	arquivos, documentos e anexos enviados;
•	preferências de contato.

3.7.	Dados de Navegação e Uso

•	endereço IP;
•	data e hora de acesso;
•	navegador;
•	sistema operacional;
•	dispositivo utilizado;
•	páginas visitadas;
•	localização aproximada;
•	identificadores de sessão;
•	cookies e dados de navegação.

    `,
  },
  {
    titulo: "4.	COMO OS DADOS SÃO COLETADOS",
    conteudo: `
Os dados poderão ser coletados:
•	diretamente pelo usuário, ao preencher formulários, criar conta ou enviar documentos;
•	durante o atendimento por WhatsApp, telefone, e-mail, redes sociais ou chat;
•	quando o usuário cria anúncio, solicita locação, troca, venda, compra ou reserva;
•	quando o usuário realiza pagamento ou solicita financiamento;
•	automaticamente, por meio de cookies e tecnologias de rastreamento;
•	por meio de parceiros, resorts, hotéis, administradoras, financeiras, processadores de pagamento, plataformas de hospedagem, redes sociais e prestadores de serviço;
•	quando terceiros enviam informações necessárias para a prestação do serviço.
    `,
  },
  {
    titulo: "5.	FINALIDADES DO TRATAMENTO",
    conteudo: `
A Multicotas poderá utilizar os dados pessoais para:

5.1.	Cadastro e Administração da Conta

•	criar e administrar contas e cadastros;
•	identificar e autenticar usuários;
•	manter dados atualizados.

5.2.	Prestação dos Serviços

•	anunciar cotas, semanas e períodos;
•	intermediar venda, locação, troca e reserva;
•	identificar compatibilidades entre interessados e proprietários;
•	viabilizar hospedagem, check-in e uso dos serviços;
•	processar solicitações de reserva e propostas.

5.3.	Validação de Titularidade e Prevenção à Fraude

•	verificar a titularidade da cota;
•	validar documentos;
•	evitar fraudes, falsidade ideológica, chargeback e uso indevido;
•	detectar atividades suspeitas.

5.4.	Pagamentos, Cobranças e Repasses

•	processar pagamentos e cobranças;
•	emitir comprovantes e notas fiscais;
•	realizar repasses aos proprietários;
•	controlar taxas, comissões, parcelamentos e reembolsos.

5.5.	Financiamento

•	encaminhar documentos e dados às instituições financeiras;
•	solicitar análise de crédito;
•	viabilizar eventual financiamento ou parcelamento.
5.6.	Comunicação

•	responder solicitações;
•	prestar atendimento;
•	enviar avisos, confirmações, atualizações, cobranças e informações sobre reservas;
•	enviar mensagens operacionais por WhatsApp, e-mail ou telefone.

5.7.	Marketing

•	enviar campanhas, promoções, oportunidades, conteúdos e comunicações publicitárias;
•	personalizar anúncios;
•	medir resultados de campanhas.

5.8.	Cumprimento de Obrigações Legais

•	cumprir obrigações fiscais, tributárias, regulatórias e legais;
•	atender solicitações de autoridades;
•	defender direitos em processos judiciais, administrativos ou arbitrais

    `,
  },
  {
    titulo: "6.	BASES LEGAIS UTILIZADAS",
    conteudo: `
6.1.	Os dados pessoais poderão ser tratados com fundamento nas seguintes bases legais previstas na LGPD:
•	execução de contrato ou de procedimentos preliminares relacionados a contrato;
•	cumprimento de obrigação legal ou regulatória;
•	exercício regular de direitos em processo judicial, administrativo ou arbitral;
•	legítimo interesse da Multicotas, inclusive para prevenção à fraude, segurança, melhoria dos serviços e comunicação;
•	consentimento do titular, quando necessário;
•	proteção ao crédito.

6.2.	O consentimento será utilizado apenas quando exigido por lei ou quando não houver outra base legal aplicável.

    `,
  },
  {
    titulo: "7.	COMPARTILHAMENTO DE DADOS",
    conteudo: `
A Multicotas poderá compartilhar dados pessoais, sempre no limite necessário para a finalidade específica, com:

7.1.	Resorts, Hotéis e Administradoras

Para viabilizar hospedagem, confirmação de titularidade, autorização de uso, check-in, venda, locação ou troca.

7.2.	Proprietários, Compradores, Vendedores e Hóspedes

Quando necessário para a conclusão da negociação, hospedagem, transferência, locação ou troca.

7.3.	Processadores de Pagamento e Instituições Financeiras

Para cobrança, pagamento, parcelamento, reembolso, análise de crédito e financiamento.

7.4.	Plataformas de Turismo e Hospedagem

Quando houver integração ou divulgação de reservas em plataformas parceiras.

7.5.	Parceiros Jurídicos e Cartórios

Para elaboração de contratos, procurações, cessões, transferência de cotas e medidas legais.

7.6.	Empresas de Tecnologia e Atendimento

A Multicotas poderá utilizar ferramentas de hospedagem em nuvem, CRM, automação, analytics, marketing e atendimento.

7.7.	Autoridades Públicas

Quando houver obrigação legal, ordem judicial, requisição administrativa ou necessidade de defesa de direitos.

    `,
  },
  {
    titulo: "8.	PARCEIROS E PLATAFORMAS UTILIZADAS",
    conteudo: `
8.1.	Dependendo do serviço contratado, a Multicotas poderá compartilhar ou tratar dados por meio de parceiros e plataformas como:
•	Meta, incluindo WhatsApp, Facebook e Instagram;
•	Google, incluindo Google Analytics, Gmail e Google Ads;
•	Asaas e outros intermediadores de pagamento;
•	Airbnb, Booking.com, Expedia e plataformas similares;
•	ZapSign e outras plataformas de assinatura eletrônica utilizadas para assinatura de contratos, procurações, termos, cessões e documentos relacionados;
•	plataformas auxiliares de assinatura eletrônica, validação documental e autenticação;
•	serviços de armazenamento em nuvem;
•	provedores de e-mail, CRM, automação e atendimento.

8.2.	O uso dessas ferramentas poderá envolver tratamento de dados por terceiros, conforme as políticas próprias de cada plataforma.

    `,
  },
  {
    titulo: "9.	TRANSFERÊNCIA INTERNACIONAL DE DADOS",
    conteudo: `
9.1.	Alguns fornecedores, parceiros e plataformas utilizados pela Multicotas poderão armazenar ou processar dados em servidores localizados fora do Brasil.

9.2.	Isso pode ocorrer, por exemplo, no uso de serviços de nuvem, e-mail, marketing, atendimento, WhatsApp, Meta, Google, plataformas de hospedagem e intermediadores internacionais.

9.3.	A Multicotas adotará medidas razoáveis para assegurar que as transferências internacionais observem a legislação aplicável e níveis adequados de proteção.

    `,
  },
  {
    titulo: "10.	COOKIES E TECNOLOGIAS DE RASTREAMENTO",
    conteudo: `
A Multicotas poderá utilizar cookies, pixels e tecnologias similares.

10.1.	Cookies Essenciais
Necessários para funcionamento do site, login, sessão e segurança.

10.2.	Cookies de Analytics
Utilizados para compreender o comportamento dos usuários, medir acessos e melhorar os serviços.

10.3.	Cookies de Marketing e Remarketing
Utilizados para personalizar anúncios, recuperar visitantes e medir campanhas.
10.3.1.	A Multicotas poderá utilizar ferramentas como Google Analytics, Google Ads, Meta Pixel e recursos semelhantes.
10.3.2.	O usuário poderá configurar seu navegador para bloquear ou remover cookies, embora isso possa limitar determinadas funcionalidades.
    `,
  },
  {
    titulo: "11.	COMUNICAÇÕES E MARKETING",
    conteudo: `
11.1.	A Multicotas poderá enviar comunicações relacionadas aos serviços, incluindo:
•	confirmações;
•	avisos;
•	atualizações de reserva;
•	cobranças;
•	oportunidades;
•	campanhas promocionais;
•	newsletters;
•	conteúdos informativos.

11.2.	As comunicações poderão ser realizadas por:
•	e-mail;
•	WhatsApp;
•	SMS;
•	telefone;
•	notificações no site ou aplicativo.
•	redes sociais, incluindo Instagram, Facebook, YouTube e outras plataformas utilizadas pela Multicotas;
•	Telegram e aplicativos similares de mensagens.

11.3.	O usuário poderá solicitar, a qualquer momento, a interrupção do envio de mensagens promocionais.

11.4.	Mesmo após essa solicitação, a Multicotas poderá continuar enviando comunicações estritamente necessárias à execução dos serviços contratados.

    `,
  },
  {
    titulo: "12.	PREVENÇÃO À FRAUDE E SEGURANÇA DAS OPERAÇÕES",
    conteudo: `
12.1.	Para proteção da plataforma e dos usuários, a Multicotas poderá:
•	validar identidade e titularidade;
•	exigir documentos adicionais;
•	cruzar informações;
•	consultar bases antifraude;
•	verificar inconsistências;
•	monitorar comportamentos suspeitos;
•	suspender anúncios, reservas, pagamentos ou cadastros;
•	reter temporariamente valores;
•	bloquear ou cancelar operações suspeitas.

12.2.	Essas medidas poderão ser adotadas sem aviso prévio quando necessárias à segurança, prevenção de fraude, chargeback, falsidade documental, tentativa de golpe ou violação dos Termos de Uso.
    `,
  },
  {
    titulo: "13.	ARMAZENAMENTO E RETENÇÃO DOS DADOS",
    conteudo: `
13.1.	Os dados serão armazenados apenas pelo tempo necessário para cumprir as finalidades desta Política, observando-se os prazos legais e regulatórios aplicáveis.
Em regra:
•	dados cadastrais e contratos: até 5 anos após o término da relação;
•	documentos de titularidade e procurações: até 5 anos após o encerramento ou término da validade;
•	dados financeiros, fiscais e de pagamento: conforme prazo legal aplicável;
•	dados de reserva e hospedagem: até 5 anos;
•	logs de acesso: entre 6 meses e 1 ano;
•	dados utilizados para marketing: até oposição do titular ou revogação do consentimento.

13.2.	Após o término do prazo aplicável, os dados poderão ser eliminados, anonimizados ou mantidos quando necessários ao cumprimento de obrigação legal, regulatória ou para defesa de direitos.

    `,
  },
  {
    titulo: "14.	SEGURANÇA DA INFORMAÇÃO",
    conteudo: `
14.1.	A Multicotas adota medidas técnicas, administrativas e organizacionais razoáveis para proteger os dados pessoais, incluindo:
•	controle de acesso;
•	autenticação;
•	armazenamento seguro;
•	restrição de acesso a colaboradores e parceiros autorizados;
•	monitoramento;
•	procedimentos internos de segurança;
•	criptografia, quando aplicável.

14.2.	Apesar dos esforços, nenhum sistema é completamente seguro ou invulnerável. Assim, a Multicotas não pode garantir segurança absoluta contra acessos não autorizados, falhas, ataques ou vazamentos.

    `,
  },
  {
    titulo: "15.	DADOS DE CRIANÇAS E ADOLESCENTES",
    conteudo: `
15.1.	A Multicotas não direciona seus serviços a menores de idade.

15.2.	Entretanto, dados de crianças e adolescentes poderão ser tratados quando necessários para reservas, hospedagem, check-in ou exigências legais, sempre sob responsabilidade de seus pais ou responsáveis legais.

    `,
  },
  {
    titulo: "16.	DIREITOS DO TITULAR",
    conteudo: `
16.1.	Nos termos da LGPD, o titular poderá solicitar:
•	confirmação da existência de tratamento;
•	acesso aos dados;
•	correção de dados incompletos, inexatos ou desatualizados;
•	anonimização, bloqueio ou eliminação;
•	portabilidade;
•	informações sobre compartilhamento;
•	oposição ao tratamento;
•	revogação do consentimento, quando aplicável.

16.2.	A Multicotas poderá solicitar documentos e informações adicionais para confirmar a identidade do solicitante antes de atender ao pedido.

    `,
  },
  {
    titulo: "17.	COMO EXERCER SEUS DIREITOS",
    conteudo: `
17.1.	As solicitações relacionadas a dados pessoais poderão ser encaminhadas ao canal de privacidade da Multicotas:
•	E-mail: privacidade@multicotas.com.br

17.2.	O pedido deverá conter, sempre que possível:
•	nome completo;
•	CPF;
•	e-mail utilizado no cadastro;
•	descrição clara da solicitação.

17.3.	A Multicotas poderá responder em até 15 dias, nos termos da legislação aplicável.
    `,
  },
  {
    titulo: "18.	ALTERAÇÕES DESTA POLÍTICA",
    conteudo: `
18.1.	A presente Política poderá ser alterada a qualquer momento, especialmente em razão de mudanças legais, regulatórias, operacionais ou nos serviços prestados.

18.2.	Em caso de alterações relevantes, a Multicotas poderá comunicar os usuários por e-mail, WhatsApp, aviso no site, área do usuário ou outro meio adequado.

18.3.	A versão mais atualizada estará sempre disponível nos canais oficiais da Multicotas.
    `,
  },
  {
    titulo: "19.	FORO",
    conteudo: `
19.1.	Esta Política será interpretada de acordo com a legislação brasileira.

19.2.	Fica eleito o foro da comarca do Rio de Janeiro, com renúncia a qualquer outro, por mais privilegiado que seja, para dirimir eventuais controvérsias relacionadas a esta Política, ressalvados os direitos previstos na legislação aplicável.
    `,
  },
 

];

const Container = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem;
  background: #fff;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

const ContainerTermo = styled.div`
  width: 100%;
  max-width: 80rem;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 10px 30px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 767px) {
    border-radius: 14px;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem 0.5rem 1rem;
  box-sizing: border-box;
`;

const Titulo = styled.h1`
  text-align: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.1rem;
  width: 100%;
  margin: 0;
  line-height: 1.4;

  @media (min-width: 768px) {
    font-size: 1.35rem;
  }

  @media (min-width: 1200px) {
    font-size: 1.55rem;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  box-sizing: border-box;

  a {
    color: #2d3436;
  }

  a:hover {
    color: #636e72;
  }

  details {
    border: 1px solid #dfe6e9;
    border-radius: 12px;
    padding: 1rem 1rem 0.6rem 1rem;
    margin-bottom: 1rem;
    background: #fff;
  }

  summary {
    cursor: pointer;
    font-weight: bold;
    color: ${Globais.CorAzulBackGround};
    font-size: 1rem;
    line-height: 1.5;
    outline: none;
  }

  @media (min-width: 768px) {
    padding: 1.5rem 2rem 2rem 2rem;
  }

  @media (min-width: 1200px) {
    padding: 1.5rem 3rem 2.5rem 3rem;
  }
`;

const Atualizacao = styled.h3`
  text-align: right;
  color: ${Globais.CorAzulBackGround};
  font-size: 0.95rem;
  margin: 0 0 1.5rem 0;
`;

const Aviso = styled.div`
  background: #f1f5f9;
  border-left: 4px solid ${Globais.CorAzulBackGround};
  color: #2d3436;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  line-height: 1.7;
  font-size: 0.95rem;
`;

const Texto = styled.div`
  white-space: pre-line;
  color: #2d3436;
  line-height: 1.8;
  font-size: 0.95rem;
  padding-top: 1rem;
  padding-bottom: 0.4rem;
  word-break: break-word;
`;

export default function ViewPoliticaPrivacidade() {
  return (
    <Container>
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>
            POLITICA DE PRIVACIDADE E PROTEÇÃO DE DADOS
            <br />
            DA PLATAFORMA MULTICOTAS
          </Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <Atualizacao>Última Atualização: 28 de março de 2026</Atualizacao>

        

          {secoes.map((secao, index) => (
            <details key={`${index}-${secao.titulo}`} open={index === 0}>
              <summary>{secao.titulo}</summary>
              <Texto>{secao.conteudo}</Texto>
            </details>
          ))}
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}